export default __webpack_public_path__ + "static/nutcracker-logo-white-24b93ad7106fcd1b2ce77217f6ce6a21.svg";